/**
 * Encodes a string to base64, supporting the full Unicode range.
 * Unlike native `btoa`, this handles characters outside Latin1
 * by first encoding them as UTF-8 bytes.
 */
export function toBase64(str: string): string {
  return btoa(Array.from(new TextEncoder().encode(str), (byte) => String.fromCodePoint(byte)).join(''));
}

/**
 * Decodes a base64 string back to a full Unicode string.
 * Reverse of `toBase64`.
 */
export function fromBase64(base64: string): string {
  const binaryString = atob(base64);
  const bytes = Uint8Array.from(binaryString, (char) => char.codePointAt(0) as number);
  return new TextDecoder().decode(bytes);
}
